module.exports = __webpack_public_path__ + "img/news8.136089fd.jpg";